import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * Slice to store dummy data for fallback when user's company data is empty
 */

interface DummyDataState {
  messages: any | null;
  results: any | null;
  balance: any | null;
  flow: any | null;
  metrics: any | null;
}

const initialState: DummyDataState = {
  messages: null,
  results: null,
  balance: null,
  flow: null,
  metrics: null,
};

const dummyDataSlice = createSlice({
  name: "dummyData",
  initialState,
  reducers: {
    setDummyMessages: (state, action: PayloadAction<any>) => {
      state.messages = action.payload;
    },
    setDummyResults: (state, action: PayloadAction<any>) => {
      state.results = action.payload;
    },
    setDummyBalance: (state, action: PayloadAction<any>) => {
      state.balance = action.payload;
    },
    setDummyFlow: (state, action: PayloadAction<any>) => {
      state.flow = action.payload;
    },
    setDummyMetrics: (state, action: PayloadAction<any>) => {
      state.metrics = action.payload;
    },
    clearDummyData: (state) => {
      state.messages = null;
      state.results = null;
      state.balance = null;
      state.flow = null;
      state.metrics = null;
    },
  },
});

export const {
  setDummyMessages,
  setDummyResults,
  setDummyBalance,
  setDummyFlow,
  setDummyMetrics,
  clearDummyData,
} = dummyDataSlice.actions;

export default dummyDataSlice.reducer;
